import { render, staticRenderFns } from "./CustomOptionSelector.vue?vue&type=template&id=06f9349b&scoped=true"
import script from "./CustomOptionSelector.vue?vue&type=script&lang=js"
export * from "./CustomOptionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f9349b",
  null
  
)

export default component.exports